import moment from "moment";
import { enquireScreen } from "enquire-js";

var _isDate = require("lodash/isDate");
var numeral = require("numeral");

numeral.register("locale", "tr", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t",
  },
  currency: {
    symbol: "₺",
  },
});

numeral.locale("tr");

export const isDate = (date) => {
  const formats = [
    "YYYY-MM-DDTHH:mm:ss.000+0000",
    "YYYY-MM-DDTHH:mm:ssZ",
    "YYYY-MM-DDT00:00:00",
  ];

  try {
    if (_isDate(date)) return true;
    return moment(date, formats, true).isValid();
  } catch {
    return false;
  }
};

export const formatDate = (date) => {
  return moment(`${date}.000+0000`).utcOffset(180).format("DD.MM.YYYY HH:mm");
};

export const fixDates4Post = (obj) => {
  if (!obj) return;
  for (const [key, value] of Object.entries(obj)) {
    if (isDate(value)) {
      if (!["createdAt", "updatedAt"].includes(key))
        obj[key] = moment(value).format("YYYY-MM-DDT00:00:00");
    } else if (obj[key] && typeof obj[key] === "object")
      fixDates4Post(obj[key]);
    else if (Array.isArray(obj[key]))
      obj[key].forEach((item) => fixDates4Post(item));
  }
  return obj;
};

export const fixDates = (obj) => {
  for (const [key, value] of Object.entries(obj)) {
    if (isDate(value)) obj[key] = moment(value);
    else if (obj[key] && typeof obj[key] === "object") fixDates(obj[key]);
  }
  return obj;
};

export const CheckIfDateRangeOverlaps = (a_start, a_end, b_start, b_end) => {
  if (a_start < b_start && b_start < a_end) return true;
  if (a_start < b_end && b_end < a_end) return true;
  if (b_start < a_start && a_end < b_end) return true;
  return false;
};

export const clean = (obj) => {
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === "object" && !isDate(obj[key])) {
      if (Object.keys(obj[key]).length > 0) clean(obj[key]);
      else delete obj[key];

      if (obj[key] && Object.keys(obj[key]).length <= 0) {
        delete obj[key];
      }
    } else if (
      obj[key] == null ||
      obj[key] === {} ||
      typeof obj[key] === undefined
    )
      delete obj[key]; // delete
  });
};

export const arrayEquals = (a, b) => {
  return (
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((val, index) => val === b[index])
  );
};

export const isScreenMobile = () => {
  let result = false;
  enquireScreen((isMobile) => {
    result = true;
  });
  return result;
};

export const formatCurrency = (amount, currency) => {
  try {
    switch (currency) {
      case "TURKISH_LIRA":
        currency = "₺";
        break;
      case "US_DOLLAR":
        currency = "$";
        break;
      case "EURO":
        currency = "€";
        break;
    }

    return `${numeral(amount).format("0,0[.]00")} ${currency || ""}`;
  } catch (err) {
    return amount;
  }
};

export const IsFloat = (n) => {
  return Number(n) === n && n % 1 !== 0;
};

export const GenerateBackPath = (path, ind) => {
  try {
    const pathArr = path.split("/");
    const url = pathArr.splice(0, ind).join("/");
    return url;
  } catch {
    return "";
  }
};

export const truncateStr = (str, n) => {
  return str.length > n ? str.substr(0, n - 1) + "..." : str;
};

export const compareDates = (a, b) => {
  if (!isDate(a) && !isDate(b)) return 0;
  if (!isDate(a)) return -1;
  if (!isDate(b)) return 1;

  if (moment(a).isAfter(moment(b))) return 1;
  if (moment(b).isAfter(moment(a))) return -1;
  return 0;
};

export const sort = (a, b) => {
  if (!a && !b) return 0;
  if (!a && b) return -1;
  if (a && !b) return 1;

  switch (typeof a) {
    case "number":
      return a - b;
    default:
      if (isDate(a)) {
        return compareDates(a, b);
      } else {
        return a.toString().localeCompare(b.toString(), "tr");
      }
  }
};
